export default __webpack_public_path__ + "static/media/lumber.244b1a2a.svg";